<ng-container *ngIf="data">
<h2 class="card-heading mb-0" [id]="id + '-title'">{{ 'voting_details.title' | translate }}</h2>
<ng-container *ngIf="resultSummary !== undefined; else simpleSummary">
    <valg-dk-result-summary [resultSummary]="resultSummary"></valg-dk-result-summary>
</ng-container>
<ng-template #simpleSummary>
    <valg-dk-simple-result-summary [resultType]="resultType"></valg-dk-simple-result-summary>
</ng-template>
<dl class="description-list mb-5" [class.wide]="data.countedPollingAreas">
    <ng-container >
        <dt class="border">{{ 'voting_details.entitled_to_vote' | translate }}</dt>
        <dd class="border">{{ formatNumberWithDotSeparator(data.numberOfVoters) }}</dd>
    </ng-container>
  <ng-container *ngIf="data.pollingStationName">
    <dt class="border">{{ 'voting_details.election_area_name' | translate }}</dt>
    <dd class="border">{{ data.pollingStationName }}</dd>
    <dt class="border">{{ 'voting_details.address' | translate }}</dt>
    <dd class="border">{{ data.address }}</dd>
  </ng-container>
    <ng-container *ngIf="data.countedPollingAreas">
        <dt class="border">{{ 'voting_details.counted_polling_districts' | translate }}</dt>
        <dd class="border">{{ 'voting_details.x_of_x' | translate: data.countedPollingAreas }}</dd>
    </ng-container>
    <ng-container *ngFor="let item of list">
        <dt class="border">{{ item.label | translate }}</dt>
        <dd class="border">{{ item.value }}</dd>
    </ng-container>
</dl>
   <table class="table simple-table" [attr.aria-describedby]="id + '-title'">
        <thead class="sr-only">
            <tr>
                <th>{{ 'voting_details.votes_table.vote_type' | translate }}</th>
                <th>{{ 'voting_details.votes_table.number_of_votes' | translate }}</th>
                <th>{{ 'voting_details.votes_table.diff' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container
                *ngTemplateOutlet="voteTemplate;context:{votes: data.validVotes, label: 'voting_details.valid_votes' }">
            </ng-container>
            <ng-container
                *ngTemplateOutlet="voteTemplate;context:{votes: data.invalidVotes, label: 'voting_details.invalid_votes' }">
            </ng-container>
            <ng-container
                *ngTemplateOutlet="voteTemplate;context:{votes: data.blankVotes, label: 'voting_details.blank_votes' }">
            </ng-container>
            <ng-container
                *ngTemplateOutlet="voteTemplate;context:{votes: data.totalVotes, label: 'voting_details.total_votes' }">
            </ng-container>
        </tbody>
   </table>
</ng-container>
<ng-template #voteTemplate let-votes="votes" let-label="label">
  <tr *ngIf="votes">
    <td>{{ label | translate }}</td>
    <td class="align-text-right">{{ getVoteNumberDisplay(votes.value) }}</td>
    <td 
    *ngIf="shouldShowVoteDifferenceColumn"
    class="align-text-right" 
    [class.text--positive]="votes.diff > 0" 
    [class.text--negative]="votes.diff < 0">
    {{ formatDiff(votes) }}
    </td>
  </tr>
</ng-template>
